const SDK_VERSION = "11.5.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
